import React from 'react';

import { flagStyles } from '../settings';

const SvgLR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3096px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgLR;
